import { IContractsRepository } from 'modules/customer/domain/repositories';
import { makeHTTPProvider } from 'shared/infra/providers';

import VectisContractsRepository from './implementations/VectisContractsRepository';

let instance: IContractsRepository | null = null;

export default function makeContractsRepository() {
  if (!instance) {
    const httpProvider = makeHTTPProvider();

    instance = new VectisContractsRepository(httpProvider);
  }

  return instance;
}
